<template>
    <div>
    <div>
        <p style="margin-bottom: 0; font-weight:700;">Vorname</p>
        <p v-for="error in errors.collect(question.id+'firstName')" :key="error" class="errorText">
            {{ error }}
        </p>
        <input 
            type="text" 
            v-model="itemValue.firstName.value" 
            v-validate="{rules: {'required': true}}"
            :name="question.id+'firstName'" 
            :class="{'error': errors.has(question.id+'firstName')}"
            :id="'' + question.id + 'firstName'">
    </div>
    <div>
        <p style="margin-bottom: 0; font-weight:700;">Nachname</p>
        <p v-for="error in errors.collect(question.id+'lastName')" :key="error" class="errorText">
            {{ error }}
        </p>
        <input 
            type="text" 
            v-model="itemValue.lastName.value" 
            v-validate="{rules: {'required': true}}"
            :name="question.id+'lastName'" 
            :class="{'error': errors.has(question.id+'lastName')}"
            :id="'' + question.id + 'lastName'">
    </div>
    <div>
        <p style="margin-bottom: 0; font-weight:700;">Straße</p>
        <p v-for="error in errors.collect(question.id+'street')" :key="error" class="errorText">
            {{ error }}
        </p>
        <input 
            type="text" 
            v-model="itemValue.street.value" 
            v-validate="{rules: {'required': true}}"
            :name="question.id+'street'" 
            :class="{'error': errors.has(question.id+'street')}"
            :id="'' + question.id + 'street'">
    </div>
    <div>
        <p style="margin-bottom: 0; font-weight:700;">Hausnummer</p>
        <p v-for="error in errors.collect(question.id+'number')" :key="error" class="errorText">
            {{ error }}
        </p>
        <input 
            type="text" 
            v-model="itemValue.number.value" 
            v-validate="{rules: {'required': true}}"
            :name="question.id+'number'" 
            :class="{'error': errors.has(question.id+'number')}"
            :id="'' + question.id + 'number'">
    </div>
    <div>
        <p style="margin-bottom: 0; font-weight:700;">PLZ</p>
        <p v-for="error in errors.collect(question.id+'zip')" :key="error" class="errorText">
            {{ error }}
        </p>
        <input 
            type="text" 
            v-model="itemValue.zip.value" 
            v-validate="{rules: {'required': true, 'numeric': true, 'min': [4], 'max': [5]}}"
            :name="question.id+'zip'" 
            :class="{'error': errors.has(question.id+'zip')}"
            :id="'' + question.id + 'zip'">
    </div>
    <div>
        <p style="margin-bottom: 0; font-weight:700;">Ort</p>
        <p v-for="error in errors.collect(question.id+'city')" :key="error" class="errorText">
            {{ error }}
        </p>
        <input 
            type="text" 
            v-model="itemValue.city.value" 
            v-validate="{rules: {'required': true}}"
            :name="question.id+'city'" 
            :class="{'error': errors.has(question.id+'city')}"
            :id="'' + question.id + 'city'">
    </div>
    <div>
        <p style="margin-bottom: 0; font-weight:700;">Land</p>
        <p v-for="error in errors.collect(question.id+'country')" :key="error" class="errorText">
            {{ error }}
        </p>
        <select 
            v-model="itemValue.country.value" 
            :name="question.id+'country'" 
            :class="{'error': errors.has(question.id+'country')}"
            :id="'' + question.id + 'country'">
            <option v-for="country in countries" v-bind:value="country" :key="country">{{ country }}</option>
        </select>
    </div>
    </div>
</template>
<script>
    import { Validator } from 'vee-validate';

	export default {
		name: 'profileAddressEditor',
		props: {
            item: Object,
            question: Object
        },
        inject: ['$validator'],
        data: function() {
            if (this.item.propertyValue == null) {
                this.item.propertyValue = {
                    firstName: { value: '' },
                    lastName: { value: '' },
                    street: { value: '' },
                    number: { value: '' },
                    zip: { value: '' },
                    city: { value: '' },
                    country: { value: '' },
                    type: {
                        kind: 'ADDRESS'
                    }
                }
            }
        	return {
	    	    countries: [],
	    	    countriesLoaded: false,
                itemValue: this.item.propertyValue
        	}
        },
        watch: {
            itemValue: {
                handler: function(oldValue, newValue) {
                    this.$emit('updateValue', this.question);
                },
                deep: true
            }
        },
        created: function() {
		    this.loadCountries();
        },
        mounted: function() {
            this.$validator.validate('' + this.question.id + 'firstName');
            this.$validator.validate('' + this.question.id + 'lastName');
            this.$validator.validate('' + this.question.id + 'street');
            this.$validator.validate('' + this.question.id + 'number');
            this.$validator.validate('' + this.question.id + 'zip');
            this.$validator.validate('' + this.question.id + 'city');
        },
        methods: {
		   loadCountries: function() {
			   jQuery.ajax ({
	                url: '/getCountryChoices',
	                type: 'GET',
	                dataType: "json",
	                success: this.loadCountriesSuccess,
	                error: function() {alert("error2");}
	            });
		   },
		   loadCountriesSuccess: function(data) {
	           this.countries = data;
	           if(this.countries.indexOf('Deutschland')>-1) {
    	        	// this.question.answer.value.country = 'Deutschland';
	           }
	           this.countriesLoaded = true;
	       },
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileAddressEditor.vue?46f1e629